// CombatStateSync.js - 多人可见的战斗属性同步
import DebugHelper from './DebugHelper.js';

/** 允许通过 playerState 广播的字段 */
export const COMBAT_SYNC_FIELDS = [
    'hp', 'maxHp', 'attack', 'defense', 'speed', 'level', 'exp',
    'cost', 'maxCost', 'element', 'battle', 'class', 'inVehicle',
    'playerName', 'name'
];

/**
 * 提取可同步的战斗快照
 * @param {Object} player
 * @returns {Object}
 */
export function getCombatSnapshot(player) {
    if (!player) {
        return {};
    }

    const snapshot = {};

    COMBAT_SYNC_FIELDS.forEach((key) => {
        if (player[key] !== undefined && player[key] !== null) {
            snapshot[key] = player[key];
        }
    });

    if (!snapshot.playerName && player.name) {
        snapshot.playerName = player.name;
    }

    return snapshot;
}

/**
 * 将战斗属性同步到服务器（同房间其他客户端可见）
 * @param {import('./NetworkManager.js').default|null} networkManager
 * @param {Object} player
 */
export function publishCombatState(networkManager, player) {
    if (!networkManager || !networkManager.isConnected() || !player) {
        return;
    }

    const snapshot = getCombatSnapshot(player);
    if (Object.keys(snapshot).length === 0) {
        return;
    }

    networkManager.updatePlayerState(snapshot);
    DebugHelper.log('CombatStateSync: 已同步战斗属性', snapshot);
}
